"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var dataSources;
        (function (dataSources) {
            var index;
            (function (index) {
                class InitArgs {
                    constructor() {
                        this.types = [];
                        this.dataSourcesCreate = appn.emptyString;
                        this.dataSourcesIndex = appn.emptyString;
                    }
                }
                let _initArgs;
                let _dataTable = null;
                function init(args) {
                    _initArgs = args;
                    createDataTable();
                }
                index.init = init;
                function createDataTable() {
                    appn.folderFilter.init(_initArgs.dataSourcesIndex);
                    _dataTable = appn.dataTable.create('.dataTable', {
                        sAjaxSource: 'DataSources/DataTable',
                        fnServerData: function (data) {
                            data.push({ name: 'sCustom_0', value: appn.folderFilter.getStateOrDefault().value }, appn.dataTable.getStateOrDefault('sCustom_1', $('#sCustom_1').val()));
                        },
                        aaSorting: [[1, 'asc']],
                        autoWidth: false,
                        aoColumns: [
                            { bSortable: false, sWidth: '3%' },
                            { bSortable: true, sWidth: '50%' },
                            { bSortable: true, sWidth: '12%' },
                            { bSortable: true, sWidth: '17%' },
                            { bSortable: true, sWidth: '17%' }
                        ],
                        fnInitComplete: function () {
                            let navbarActionButtons = [
                                { buttonId: 'organiseBtn', buttonType: 'Organise', isDataTableToggleBtn: true },
                                { buttonId: 'manageBtn', buttonType: 'Manage', isDataTableToggleBtn: true }
                            ];
                            appn.actionButtons.renderNavbarActionButtons(navbarActionButtons, appn.requestUser.isUserOrHigher, true);
                            appn.actionButtons.renderNavbarActionButtons([
                                { buttonId: 'addnew', buttonType: 'AddNew' }
                            ], appn.requestUser.isUserOrHigher);
                            $('#addnew').click(function (e) {
                                e.preventDefault();
                                appn.location.navTo(_initArgs.dataSourcesCreate, [{ name: 'folderId', value: appn.folderFilter.selectedFolderId }]);
                            });
                            appn.sideFilterAndContent.appendShowButton($('#DataTables_Table_0_filter'));
                            $('#organiseBtn').click(function (e) {
                                e.preventDefault();
                                appn.folderFilter.showDialog($(this));
                            });
                            $('#manageBtn').click(function (e) {
                                e.preventDefault();
                                const selectedRows = $('.dataTable').find('.selectRow:checked');
                                if (selectedRows.length > 0) {
                                    let ids = '';
                                    $(selectedRows).map(function () {
                                        ids += ($(this).attr('id')) + ',';
                                    });
                                    $('#dataSourcesToManage').val(ids);
                                    $('#manageDataSourcesDialog').modal('show');
                                    const submitButton = $('#manageDataSourcesDialog .card-header button[value="Manage_Trash"].btn-tool-danger');
                                    appn.trash.createTrashMessageFromTable(submitButton, selectedRows, T('Data Sources'));
                                }
                            });
                            $('.dataTables_filter').prepend(appn.elementBuilder.buildSelect(_initArgs.types, 'sCustom_1', 'form-control-sm form-control saveMeState', T('ALL TYPES')));
                            appn.dataTable.addSearchPlaceholder(T(`Filter results where this Data Source's <b>Rows or Columns</b> contain a keyword typed in here.`));
                            appn.saveMeState.init(function () {
                                _dataTable.fnDraw(false);
                            }, function () {
                                _dataTable.fnDraw(false);
                            }, '.dataTables_filter');
                        }
                    });
                }
            })(index = dataSources.index || (dataSources.index = {}));
        })(dataSources = views.dataSources || (views.dataSources = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
